// npm packages
import { useDispatch, useSelector } from 'react-redux';
import React, { useRef } from 'react';
import { useRouter } from 'next/navigation';
import { cn } from '@/utils/cn';
import Icon from '@/app/components/Icon';
import Text from '@/app/components/Text';
import { fetchCartItemsAsync } from '@/redux/thunk/carts-thunk';
import {
  setCurrentSearchKey,
  setIsOpenGlobalSearchModal,
} from '@/redux/reducers/search-reducer';
import { spinTheWheelTypes } from '@/constants/types';
import { isSpinTheWheelEnded } from '@/utils/dateTime';
import SearchBar from '../../Input/SearchBar';
import SpinTheWheel from '../../SpinTheWheel/SpinTheWheel';

function SearchCartSpinMobile({ hideSpinTheWheel = false }) {
  const { items: cart } = useSelector((state) => state.carts);
  const dispatch = useDispatch();
  const router = useRouter();
  const inputRef = useRef(null);

  const { isSearchActive, isOpenGlobalSearchModal } = useSelector(
    (state) => state.search,
  );
  const { wheelDetails, wheelList } = useSelector(
    (state) => state.spinTheWheel,
  );

  const handleSearchInputChange = (searchData) => {
    dispatch(setCurrentSearchKey(searchData));
  };

  const handleOpenGlobalSearch = () => {
    dispatch(setIsOpenGlobalSearchModal(true));
    // dispatch(setIsSearchActive(true));
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <div
      className={cn(
        'search-and-cart-mobile flex justify-start lg:justify-end items-center gap-[16px] xl:gap-[20px] lg:pt-20 lg:pb-16 sm:pb-0',
        {
          'gap-[24px]': isSearchActive,
        },
      )}
    >
      {/* spin the wheel */}
      {!isSpinTheWheelEnded({ wheelDetails, list: wheelList }) &&
      !hideSpinTheWheel &&
      !isSearchActive &&
      !isOpenGlobalSearchModal ? (
        <SpinTheWheel type={spinTheWheelTypes.icon} />
      ) : null}

      {isOpenGlobalSearchModal && (
        <SearchBar onSearch={handleSearchInputChange} />
      )}

      {!isSearchActive && (
        <div
          className={cn(
            ' h-56 pr-0 flex lg:hidden justify-end items-center cursor-pointer',
            {
              hidden: isOpenGlobalSearchModal,
            },
          )}
        >
          <Icon type="search" color="#fff" onClick={handleOpenGlobalSearch} />
        </div>
      )}

      <div className="size-[24px] cursor-pointer relative">
        <Icon
          type="cart"
          color="#fff"
          width="24"
          height="24"
          onClick={() => {
            dispatch(setIsOpenGlobalSearchModal(false));
            dispatch(fetchCartItemsAsync());
            router.push('/cart');
          }}
        />
        {cart?.length > 0 ? (
          <Text
            type="span"
            className="bg-richcarmine w-[18px] h-[18px] flex justify-center items-center text-xss text-white font-semibold px-3 py-2 rounded-full absolute -top-2 -right-1.5"
          >
            {cart?.length}
          </Text>
        ) : null}
      </div>
    </div>
  );
}

export default SearchCartSpinMobile;
